import moment from "moment"

export const mapFetchClientsListRequest = ({ search }) => (
    {
        "search": search,
    }
)

export const mapFetchClientsListResponse = (response) => {
    return response["Usuario"]["Data"].map(data => ({
        id: data["UsuarioMobileId"],
        cpf: data["Cpf"],
        email: data["Email"],
        phone: data["Telefone"],
        name: data["NomeUsuario"],
        totalOrders: data["NumeroPedidos"],
        ordersValue: data["TotalPedido"],
        lastOrder: data["UltimoPedido"]
    }))
}

export const mapFetchClientDetailResponse = (response) => {
    return response["Usuario"]["Data"].map(data => ({
        orderId: data["ComandaId"],
        date: data["DataPedido"],
        address: {
            street: data["Endereco"],
            number: data["Numero"],
            complement: data["Complemento"],
            postalCode: data["Cep"],
            city: data["Cidade"],
            neighborhood: data["Bairro"],
        },
        discount: data["Desconto"],
        value: data["ValorPago"]
    }))
}

export const mapFetchLoyaltyDetailResponse = (response) => {

    if (!response || !response.Cartelas || response.Cartelas.length === 0) return undefined;

    let id;
    let status;

    let cards = response.Cartelas.map((card, index) => {
        if (index === 0) {
            id = card.FidelidadeId;
            status = !card.StatusFidelidade.includes('Inativa');
        }
        return {
            id: card.CartelaId,
            createdAt: card.DataCriacaoCartela ? card.DataCriacaoCartela.replace('Data Criação da Cartela: ', '') : undefined,
            status: getCardStatus(card.StatusCartelaId),
            date: dateToShow(card.DataInativou, card.DataExpirou, card.DataExpiracaoFidelidade),
            value: card.TotalPontos,
            points: card.Pontuacoes.map((point) => {
                return {
                    date: point.Data ? point.Data.replace('Data Pontuação: ', '') : undefined,
                    note: point.Observacao,
                    type: point.TipoPontuacao,
                    value: point.Valor
                }
            })

        }
    })

    const orderedCardsByStatus = cards.sort((a, b) => b.status - a.status);

    return { id, status, cards: orderedCardsByStatus };
}


const dateToShow = (dataInativou, dataExpirou, dataExpiracaoFidelidade) => {
    if (dataInativou) {
        return {
            type: 'inactive',
            date: moment(dataInativou).format('DD/MM/YYYY')
        }
    }

    return {
        type: dataExpiracaoFidelidade ? 'expireIn' : 'expire',
        date: moment(dataExpiracaoFidelidade ? dataExpiracaoFidelidade : dataExpirou).format('DD/MM/YYYY')
    }
}

const getCardStatus = (status) => {
    switch (status) {
        case 1:
            return {
                id: 'ativa',
                label: 'Ativa',
                tooltip: 'Ativa',
                status: true,
            };
        case 2:
            return {
                id: 'inativada',
                label: 'Inativa',
                tooltip: 'Inativa',
                status: false,
            };
        case 3:
            return {
                id: 'finalizada',
                label: 'Finalizada',
                tooltip: 'Finalizada',
                status: false,
            };
        case 4:
            return {
                id: 'expirada',
                label: 'Expirada',
                tooltip: 'Expirada',
                status: false,
            };
        case 5:
            return {
                id: 'expiradaPorInatividade',
                label: 'Expirada',
                tooltip: 'Expirada por inatividade',
                status: false,
            };
        case 6:
            return {
                id: 'finalizadaPorConsumo',
                label: 'Finalizada',
                tooltip: 'Finalizada por consumo',
                status: false,
            }
        case 7:
            return {
                id: 'finalizadaPorMovimentacaoInvalida',
                label: 'Finalizada',
                tooltip: 'Finalizada por movimentacao inválida',
                status: false,
            }
    }
}
